module.exports = __webpack_public_path__ + "static/media/polytope_52_3_3_layers_3_3.b1e38418.gif";